import { MetaTags } from './MetaTags';
import { Icons } from './Icons';
import { StructuredData } from './StructuredData';
import { Performance } from './Performance';

export const Head = () => {
  return (
    <>
      <MetaTags />
      <Icons />
      <StructuredData />
      <Performance />
    </>
  );
};